var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 86,
    viewBox: "0 0 82 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 82,
    height: 77.79,
    rx: 15,
    fill: "url(#paint0_linear_1_11)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9 72.63C37.0733 72.63 34.0167 71.8833 31.73 70.39C29.4433 68.8967 27.81 66.7733 26.83 64.02C25.85 61.22 25.36 57.9533 25.36 54.22V32.73C25.36 28.9967 25.85 25.8 26.83 23.14C27.8567 20.4333 29.49 18.38 31.73 16.98C34.0167 15.5333 37.0733 14.81 40.9 14.81C44.7267 14.81 47.76 15.5333 50 16.98C52.24 18.4267 53.85 20.48 54.83 23.14C55.8567 25.8 56.37 28.9967 56.37 32.73V54.29C56.37 57.9767 55.8567 61.1967 54.83 63.95C53.85 66.7033 52.24 68.85 50 70.39C47.76 71.8833 44.7267 72.63 40.9 72.63ZM40.9 66.4C43 66.4 44.5867 65.98 45.66 65.14C46.7333 64.2533 47.4567 63.04 47.83 61.5C48.2033 59.9133 48.39 58.07 48.39 55.97V31.12C48.39 29.02 48.2033 27.2233 47.83 25.73C47.4567 24.19 46.7333 23.0233 45.66 22.23C44.5867 21.39 43 20.97 40.9 20.97C38.8 20.97 37.19 21.39 36.07 22.23C34.9967 23.0233 34.2733 24.19 33.9 25.73C33.5267 27.2233 33.34 29.02 33.34 31.12V55.97C33.34 58.07 33.5267 59.9133 33.9 61.5C34.2733 63.04 34.9967 64.2533 36.07 65.14C37.19 65.98 38.8 66.4 40.9 66.4Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_11",
    x1: 25,
    y1: 73.5,
    x2: 61.5,
    y2: 31.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.143152,
    stopColor: "#022E1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#073734"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.82a40a8abc78d4b1336b73d296c7e699.svg";
export { ForwardRef as ReactComponent };